import styled from '@emotion/styled'
import { colors } from '../../shared/ui/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: ${colors.gray100};
`

export const SidebarContainer = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`

export const SidebarSlot = styled.div<{ $collapsed: boolean }>`
  width: ${({ $collapsed }) => ($collapsed ? '72px' : '223px')};
  transition: ${({ $collapsed }) =>
    $collapsed ? 'width 0.1s ease-in' : 'none'};
  overflow: hidden;
  display: flex;
  flex-shrink: 0;
`

export const MainContent = styled.main`
  flex: 1;
  overflow-y: auto;
  background-color: ${colors.gray100};
`
